import React, { Component, Fragment } from 'react';
import { Button, Carousel } from 'react-bootstrap';
import Auth from '../../Auth/Auth';
import IsLoadingBar from '../isLoading';

import './FetchTips.scss';

const auth = new Auth();

export default class FetchTips extends Component {
    constructor(props){
        super(props);

        this.state = {
            FetchTipData: [],
            fetchTipExpanded: false,
            showAllTips : this.props.showAllTips === undefined ? false : true,
            isLoading: true
        };
    }

    async componentDidMount(){
        let accessToken = await auth.getToken();
        fetch('/api/FetchTips', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
                showAll : this.props.showAllTips === undefined ? false : true
            }
        }).then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        }).then(data => {
            this.setState({     
                FetchTipData: data,
                isLoading: false
            });
        }).catch((error) => {
            window.apiError(error);
        });
    }

    async FetchTipClose(){
        if(this.props.showAllTips === undefined ? false : true){
            this.props.closeTip();
        } else {
            let accessToken = await auth.getToken();

            fetch('/api/updateFetchTips', {
                method : "POST",
                headers : {
                    'Authorization': "Bearer " + accessToken,
                    withCredentials : true,
                    crossDomain: true,
                }
            }).then(response => {
                if(response.status !== 200)
                {   
                    let payload = [{
                        status : response.status,
                        rawmsg : response.statusText,
                        cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                        location: response.url,
                        timestamp : Date.now(),
                    }];
                    throw {
                        payload: payload,
                        error: new Error()
                      };
                }
                return  response.json();
            }).then(data => {
                let userInfo = JSON.parse(localStorage.getItem("user"));
                if(userInfo !== null || userInfo !== undefined){
                    userInfo.FetchTipAvailable = 0;
                    localStorage.setItem("user",JSON.stringify(userInfo));
                } 
                this.props.closeTip();
            }).catch((error) => {
                window.apiError(error);
            });
        }  
    }

    render(){
        return (
            <Fragment>
                {!this.state.isLoading && (
                    <div className={this.state.fetchTipExpanded ? "fetch-tips expanded" : "fetch-tips"}>
                        <Button className="close" onClick={() => this.FetchTipClose()}>X</Button>
                        {this.state.isLoading ?
                        <h6 className="w-100 m-auto" style={{textAlign : "center", color: "rgb(159, 197, 255)"}}>Retrieving Tips</h6>
                        :
                        <Carousel indicators={false} interval={null} slide={false} controls={this.state.FetchTipData.length > 1}>
                            {this.state.FetchTipData.map((items, index) => 
                            <Carousel.Item key={index}>
                                <div className="fetch-tip-body">
                                    <h5 dangerouslySetInnerHTML={{ __html : items.Title}}></h5>
                                    <div className="fetch-tip-content" dangerouslySetInnerHTML={{ __html : items.Description}} style={{ fontSize: "13px" }}></div>
                                </div>
                                <div className="fetch-tip-footer">
                                    {items.LearnMore && (
                                        <Button variant="link" onClick={() => { this.setState({ fetchTipExpanded : !this.state.fetchTipExpanded}) }}><small>{this.state.fetchTipExpanded ? "Show less" : "Show more"}</small></Button>
                                    )}               
                                </div>
                            </Carousel.Item>
                            )}
                        </Carousel>
                        }
                    </div>  
                )}
            </Fragment>
        );
    }
}